import stateOptions from './states';

// name: string;
// label: string;
// fixed?: boolean;
// type: string;
// options: string[];
// isRequired: boolean;
// predefined: boolean | null;
// selection?: string;
// id?: string;
// group: string;

export default [
    {
        id: 0,
        name: 'General Information',
        isDefault: true,
        order: 0,
        fields: [
            {
                id: 'general-title',
                // Group name used by `/public/pages` as `GENERAL_INFORMATION_LONG_DESCRIPTION`
                group: 'General Information',
                label: 'Information Page Title',
                name: 'title',
                type: 'Short Text',
                options: [],
                fixed: false,
                order: 0,
                isRequired: false,
                predefined: false,
            },
            {
                id: 'general-description-short',
                // Group name used by `/public/pages` as `GENERAL_INFORMATION_LONG_DESCRIPTION`
                group: 'General Information',
                label: 'Short Description of Resource',
                name: 'short_description',
                type: 'Long Text',
                options: [],
                order: 1,
                fixed: false,
                isRequired: false,
                predefined: false,
            },
            {
                id: 'general-description-long',
                // Group name used by `/public/pages` as `GENERAL_INFORMATION_LONG_DESCRIPTION`
                group: 'General Information',
                label: 'Long Description of Resource',
                // This name is used by `/public/pages` as `GENERAL_INFORMATION_LONG_DESCRIPTION`
                name: 'long_description',
                type: 'Long Text',
                options: [],
                fixed: false,
                order: 2,
                isRequired: false,
                predefined: false,
            },
        ],
    },
    {
        id: 1,
        name: 'Contact Information',
        isDefault: true,
        order: 1,
        fields: [
            {
                id: 'fname-1',
                group: 'Contact Information',
                label: 'First Name',
                name: 'first_name',
                type: 'Short Text',
                options: [],
                isRequired: false,
                fixed: false,
                predefined: false,
            },
            {
                id: 'lname-1',
                group: 'Contact Information',
                label: 'Last Name',
                name: 'last_name',
                type: 'Short Text',
                options: [],
                fixed: false,
                isRequired: false,
                predefined: false,
            },
            {
                id: 'job-title-1',
                group: 'Contact Information',
                label: 'Job Title',
                name: 'job_title',
                type: 'Short Text',
                options: [],
                fixed: false,
                isRequired: false,
                predefined: false,
            },
            {
                id: 'pnumber-1',
                group: 'Contact Information',
                label: 'Phone Number (Work)',
                name: 'phone_number_work',
                type: 'Short Text',
                options: [],
                fixed: false,
                isRequired: false,
                predefined: false,
            },
            {
                id: 'paddr-1',
                group: 'Contact Information',
                name: 'address',
                label: 'Address',
                type: 'Short Text',
                options: [],
                fixed: false,
                isRequired: false,
                predefined: false,
            },
            {
                id: 'pnumber-2',
                group: 'Contact Information',
                label: 'Phone Number (Mobile)',
                name: 'phone_number_mobile',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'pnumber-3',
                group: 'Contact Information',
                label: 'Phone Number (Home)',
                name: 'phone_number_home',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'fax-1',
                group: 'Contact Information',
                label: 'Fax',
                name: 'fax',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'email-1',
                group: 'Contact Information',
                label: 'Email',
                name: 'email',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'website-1',
                group: 'Contact Information',
                label: 'Website',
                name: 'website',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'twitter-1',
                group: 'Contact Information',
                label: 'Twitter',
                name: 'twitter',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'fb-1',
                group: 'Contact Information',
                label: 'Facebook',
                name: 'facebook',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
        ],
    },
    {
        id: 2,
        name: 'Organization Information',
        isDefault: true,
        order: 2,
        fields: [
            {
                id: 'orgname-2',
                group: 'Organization Information',
                label: 'Organization Name',
                name: 'organization_name',
                type: 'Short Text',
                options: [],
                fixed: false,
                isRequired: false,
                predefined: false,
            },
            {
                id: 'orginfo-2',
                group: 'Organization Information',
                label: 'About Us/Organization Information',
                name: 'about_us',
                type: 'Long Text',
                options: [],
                fixed: false,
                isRequired: false,
                predefined: false,
            },
            {
                id: 'orgtype-2',
                group: 'Organization Information',
                label: 'Organization Type',
                name: 'organization_type',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'insurance-2',
                group: 'Organization Information',
                label: 'Insurance Accepted',
                name: 'insurance_accepted',
                type: 'Single Select',
                selection: 'Single',
                options: ['Yes', 'No'],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'accessible-2',
                group: 'Organization Information',
                label: 'Accessibility',
                name: 'accessibility',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'boardcert-2',
                group: 'Organization Information',
                label: 'Board Certified',
                name: 'board_certified',
                type: 'Single Select',
                selection: 'Single',
                options: ['Yes', 'No'],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'credentials-2',
                group: 'Organization Information',
                label: 'Credentials',
                name: 'credentials',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'newpatients-2',
                group: 'Organization Information',
                label: 'Accepting New Patients',
                name: 'accepting_new_patients',
                type: 'Single Select',
                selection: 'Single',
                options: ['Yes', 'No'],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'rating-2',
                group: 'Organization Information',
                label: 'Rating',
                name: 'rating',
                type: 'Single Select',
                selection: 'Single',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'parking-2',
                group: 'Organization Information',
                label: 'Parking',
                name: 'parking',
                type: 'Single Select',
                selection: 'Single',
                options: ['Free parking on site', 'Paid Parking on site', 'No parking'],
                isRequired: false,
                predefined: true,
            },
        ],
    },
    {
        id: 3,
        name: 'Location',
        isDefault: true,
        fields: [
            {
                id: 'address-3',
                group: 'Location',
                label: 'Address',
                name: 'address',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'city-3',
                group: 'Location',
                label: 'City',
                name: 'city',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'state-3',
                group: 'Location',
                label: 'State',
                name: 'state',
                type: 'Single Select',
                selection: 'Single',
                options: stateOptions.map((x) => x.name), // TODO list of states for shared use
                isRequired: false,
                predefined: true,
            },
            {
                id: 'zip-3',
                group: 'Location',
                label: 'Zip Code',
                name: 'zip_code',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'county-3',
                group: 'Location',
                label: 'County',
                name: 'county',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'parish-3',
                group: 'Location',
                label: 'Parish',
                name: 'parish',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
        ],
    },
    {
        id: 4,
        name: 'Resource Information',
        isDefault: true,
        fields: [
            {
                id: 'title-4',
                group: 'Resource Information',
                label: 'Title',
                name: 'title',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'shortdesc-4',
                group: 'Resource Information',
                label: 'Brief Description',
                name: 'brief_description',
                type: 'Short Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'longdesc-4',
                group: 'Resource Information',
                label: 'Long Description',
                name: 'long_description',
                type: 'Long Text',
                options: [],
                isRequired: false,
                predefined: false,
            },
            {
                id: 'type-4',
                group: 'Resource Information',
                label: 'Type',
                name: 'type',
                type: 'Single Select',
                selection: 'Single',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'specialty-4',
                group: 'Resource Information',
                label: 'Specialty',
                name: 'specialty',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'services-4',
                group: 'Resource Information',
                label: 'Services',
                name: 'services',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'languages-4',
                group: 'Resource Information',
                label: 'Languages Served',
                name: 'languages_served',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'availability-4',
                group: 'Resource Information',
                label: 'Availability',
                name: 'availability',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'accessibility-4',
                group: 'Resource Information',
                name: 'accessibility',
                label: 'Accessibility',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'ages-4',
                group: 'Resource Information',
                name: 'ages_served',
                label: 'Ages Served',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'gender-4',
                group: 'Resource Information',
                label: 'Genders Served',
                name: 'genders_served',
                type: 'Single Select',
                selection: 'Single',
                options: ['Female', 'Male', 'All genders'],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'topic-4',
                group: 'Resource Information',
                label: 'Topic',
                name: 'topic',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
            {
                id: 'grade-4',
                group: 'Resource Information',
                label: 'Grade Level',
                name: 'grade_level',
                type: 'Multi Select',
                selection: 'Multi',
                options: [],
                isRequired: false,
                predefined: true,
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/data/db-fields.js